// Attributes invite-link signups: the invite landing page stores the token in
// localStorage; as soon as the visitor is authenticated (fresh signup or
// existing account), claim it once and clear it.
export default defineNuxtPlugin((nuxtApp) => {
  const { status } = useAuth()
  const $api = nuxtApp.$api as (url: string, opts?: any) => Promise<any>

  watch(status, async (s) => {
    if (s !== 'authenticated') return
    const token = localStorage.getItem('sm_invite_token')
    if (!token) return
    // One attempt only — an expired or invalid token would fail forever.
    localStorage.removeItem('sm_invite_token')
    try {
      await $api(`/performance/invites/${token}/claim/`, { method: 'POST' })
    } catch (e) {
      console.error('Invite claim failed:', e)
    }
  }, { immediate: true })
})
